import { Flex, Input } from '@chakra-ui/react'
import { useId } from 'react'

import FilterField, { FILTER_CONTROL_SIZE, IFilterLayoutProps } from './FilterField'

export interface IFilterDateRangeValue {
  start: string
  end: string
}

export interface IFilterDateRangeProps extends IFilterLayoutProps {
  /** Um rótulo só para o intervalo inteiro — nada de "Data (Início)" e "Data (Fim)" lado a lado. */
  label: string
  value: IFilterDateRangeValue
  onChange: (value: IFilterDateRangeValue) => void
}

/**
 * Intervalo de datas: um rótulo, dois campos e os limites sempre cruzados — o início não passa
 * do fim e o fim não vem antes do início, o que metade das listagens não fazia.
 */
export default function FilterDateRange({
  label,
  value,
  onChange,
  // Dois campos numa célula só: o dobro da base dos vizinhos, senão quebram cedo demais,
  // e teto maior que o padrão pelo mesmo motivo.
  flex = '2 1 320px',
  maxW = '400px',
  minW
}: IFilterDateRangeProps) {
  const startId = useId()

  return (
    <FilterField label={label} htmlFor={startId} flex={flex} maxW={maxW} minW={minW}>
      <Flex gap="2">
        <Input
          id={startId}
          type="date"
          size={FILTER_CONTROL_SIZE}
          aria-label={`${label} — início`}
          value={value.start}
          // `|| undefined`: `max=""` faz o Chrome recusar qualquer data digitada.
          max={value.end || undefined}
          onChange={(e) => onChange({ ...value, start: e.target.value })}
        />
        <Input
          type="date"
          size={FILTER_CONTROL_SIZE}
          aria-label={`${label} — fim`}
          value={value.end}
          min={value.start || undefined}
          onChange={(e) => onChange({ ...value, end: e.target.value })}
        />
      </Flex>
    </FilterField>
  )
}
